<div matDialogTitle>{{title}}</div>
<mat-dialog-content>
    @if(saveMessage.length) {
    <div>
        @for (item of saveMessage; track item) {
            <p-message severity="info">{{item.summary}}</p-message>
        }        
    </div>
    }
    <ah-photo-upload [asset]="asset" [assets]="assets" (savingMessage)="savingMessage($event)" (afterUpload)="afterUpload($event)"></ah-photo-upload>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-flex-end gap-20">
    <button mat-raised-button matDialogClose class="flex-20">Cancel</button>
</mat-dialog-actions>